import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiEdit3, FiSearch, FiSmartphone, FiShield, FiTarget, FiBell, FiEye, FiRocket } = FiIcons;

const WhatYouGet = () => {
  const inclusions = [
    {
      icon: FiEdit3,
      title: 'Custom-written copy for your trade',
      description: 'Professional copywriting tailored to your specific trade and service area'
    },
    {
      icon: FiSearch,
      title: 'SEO-ready structure for your area',
      description: 'Optimised for local search results and Google rankings'
    },
    {
      icon: FiSmartphone,
      title: 'Mobile-first premium design',
      description: 'Looks professional and converts on all devices'
    },
    {
      icon: FiShield,
      title: 'Trust framework that removes doubt',
      description: 'Strategic layout that builds credibility and confidence'
    },
    {
      icon: FiTarget,
      title: 'Clear CTA and enquiry flow',
      description: 'Optimised paths to get customers calling or contacting you'
    },
    {
      icon: FiBell,
      title: 'Instant enquiry notification setup',
      description: 'Get notified immediately when customers make contact'
    },
    {
      icon: FiEye,
      title: 'Review and refinement',
      description: 'We refine the page based on your feedback before launch'
    },
    {
      icon: FiRocket,
      title: 'Launch and setup',
      description: 'Complete setup and launch with hosting included'
    }
  ];

  return (
    <section id="what-you-get" className="py-20 bg-gradient-to-br from-gray-900 to-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            What you get
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Everything you need to turn your online presence into a customer-generating asset.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {inclusions.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-6"
            >
              <div className="flex items-start gap-4">
                <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-2 rounded-lg flex-shrink-0">
                  <SafeIcon icon={item.icon} className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h3 className="text-white font-semibold mb-2">{item.title}</h3>
                  <p className="text-white/70">{item.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatYouGet;